import React from 'react';
import { PropTypes } from 'prop-types';
import Linkify from 'react-linkify';

const SiteField = ({ attribute = {}, testid = undefined }) => {
  return (
    <table className="table-fixed w-full">
      <tbody>
        {Object.keys(attribute).map((item) => (
          <tr key={item}>
            <td valign="top" className="w-44 font-normal text-vamos-gray">{item}</td>
            <td valign="top" className="break-words whitespace-normal" data-testid={testid || undefined}><Linkify>{attribute[item] || 'N/A'}</Linkify></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

SiteField.propTypes = {
  attribute: PropTypes.object,
  testid: PropTypes.string,
};

export default SiteField;
